export const pageHeaderClassName = "page-header";

export const pageHeaderHeadingGroupClassName = `${pageHeaderClassName}__heading-group`;

export const pageHeaderActionClassName = `${pageHeaderClassName}__action`;
